module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp1_9016.01875a27.png";